import { render } from "./NewsletterBox.vue?vue&type=template&id=2dc795cd&scoped=true"
import script from "./NewsletterBox.vue?vue&type=script&lang=js"
export * from "./NewsletterBox.vue?vue&type=script&lang=js"

import "./NewsletterBox.vue?vue&type=style&index=0&id=2dc795cd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dc795cd"]])

export default __exports__